<template>

  <v-dialog :value="value" @input="$emit('input')" :width="width || '290px'">
    <v-card>
      <v-card-text class="pt-10"><h2>{{ text }}</h2></v-card-text>
      <v-layout row wrap>
          <v-flex pl-10 xs8 sm8 md8 lg8>
          <v-text-field color="primary" outlined label="Add email address" v-model="email"/>
        </v-flex>
        <v-btn class="pt-5 pb-5 pt-9 pl-8 pr-8 ml-3" dark color="primary" @click="addUser(email)">
          <p>Save</p>
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  props: ['value', 'text', 'width'],
  data: () => ({
    email: ''
  }),
  methods: {
    addUser () {
      this.$emit('input', this.email)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
